export const UPLOAD_FILES_REQUEST = "UPLOAD_FILES_REQUEST";
export const UPLOAD_FILES_SUCCESS = "UPLOAD_FILES_SUCCESS";
export const UPLOAD_FILES_FAILURE = "UPLOAD_FILES_FAILURE";

export const UPDATE_FILE = "UPDATE_FILE";
export const CLEAR_FILES = "CLEAR_FILES";
